const UnauthorizedLayout = ({children}) => {
  return children
}

export default UnauthorizedLayout



// WEBPACK FOOTER //
// ./src/template/UnauthorizedLayout/index.jsx